/**
 * @author      Dario Casertano <dario@casertano.name>
 * @copyright   Copyright (c) 2022-2023 Casertano Dario – All rights reserved.
 * @license     Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International.
 */

import { DateTime } from "luxon";

export default class DateHelper {
    static readonly FORMAT_GOOGLE_CALENDAR = "yyyyLLdd'T'HHmmss'Z'"
    static readonly FORMAT_ISO8601: DateFormatIso8601 = "yyyy-LL-dd'T'HH:mm:ssZZ"
    static readonly FORMAT_SQL = "yyyy-LL-dd HH:mm:ss"
    static readonly FORMAT_SQL_MILLS = "yyyy-LL-dd HH:mm:ss.SSS"

    static to_numericFull(isoDate: string | null, def = ""): string {
        return isoDate ? DateTime.fromISO(isoDate).toFormat('dd/LL/yyyy HH:mm:ss') : def
    }

    static to_ccccdLLLLyyyy(isoDate: string | null, def = ""): string {
        return isoDate ? DateTime.fromISO(isoDate).toFormat('cccc d LLLL yyyy') : def
    }

    static to_dLLLLyyyy(isoDate: string | null, def = ""): string {
        return isoDate ? DateTime.fromISO(isoDate).toFormat('d LLLL yyyy') : def
    }

    static to_HHmm(isoDate: string | null, def = ""): string {
        return isoDate ? DateTime.fromISO(isoDate).toFormat('HH:mm') : def
    }

    static to_HHmmss(isoDate: string | null, def = ""): string {
        return isoDate ? DateTime.fromISO(isoDate).toFormat('HH:mm:ss') : def
    }

    static to_ddLLyyyy(isoDate: string | null, def = ""): string {
        return isoDate ? DateTime.fromISO(isoDate).toFormat('dd/LL/yyyy') : def
    }

    static to_LLLLyyyy(isoDate: string | null, def = ""): string {
        return isoDate ? DateTime.fromISO(isoDate).toFormat('LLLL yyyy') : def
    }
}

export type DateFormatIso8601 = string
export type DateFormatMills = number
